import React from 'react';
import { useTranslation } from 'react-i18next';

import { StyledAlert } from '../style';

interface InformationErrorProps {
  studentLength: number;
  prevStudentLength: number;
  hash: string;
}

/**
 * Komponent wyświetlający informacje ile ocen udało się przepisać oraz informacje o błędzie
 */
const InformationError = ({ prevStudentLength, studentLength, hash }: InformationErrorProps): JSX.Element => {
  const { t } = useTranslation();

  return (
    <StyledAlert
      withMarginBottom
      message={t('COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_TITLE_ERROR', {
        howMuch: prevStudentLength - studentLength,
        from: prevStudentLength,
      })}
      description={t('COPY_FINAL_MARKS_REMOVED_STUDENTS_ALERT_DESCRIPTION_ERROR', { hash: hash })}
    />
  );
};

export default InformationError;
